import { InfoPostNavConfig } from 'app/components/app-common-views/infopost-nav-container/sidebar-nav/nav-menus.constants';
import { Component, Input, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { IAppState } from 'app/store/app/app.state';
import { selectSelectedPrimaryNavConfig } from 'app/store/sidebar/sidebar.selectors';
import { HasSubscriptions } from 'shared/components/higher-order/has-subscriptions';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-infopost-sidebar-nav-drawer',
  templateUrl: './sidebar-nav-drawer.component.html',
  styleUrls: ['./sidebar-nav-drawer.component.scss'],
})
export class InfoPostSidebarNavDrawerComponent extends HasSubscriptions implements OnInit {

  selectedPrimaryNavConfig: InfoPostNavConfig;
  secondaryNavConfigs: InfoPostNavConfig[] = [];

  @Input()
  menuGuards: { [name: string]: Observable<boolean> };

  constructor(private _store: Store<IAppState>) {
    super();
  }

  ngOnInit() {
    this.addSubscription(
      this._store.pipe(select(selectSelectedPrimaryNavConfig)).subscribe(config => {
        this.selectedPrimaryNavConfig = config;
        this.secondaryNavConfigs =
          this.selectedPrimaryNavConfig && Array.isArray(this.selectedPrimaryNavConfig.subMenuItems)
            ? this.selectedPrimaryNavConfig.subMenuItems
            : [];
      })
    );
  }
}
